import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.css'],
})
export class QuantitySelectorComponent {
  @Input() value = 1;

  @Output() increment = new EventEmitter<void>();
  @Output() decrement = new EventEmitter<void>();
}
